import React from "react";
import "./LinkNavbar.css";
import { Link } from "react-router-dom";

const LinkNavbar = () => {
  return (
    <div className="secondary-header">
      <nav className="">
        <div className="py-2 container">
          <div className="d-flex justify-content-lg-start justify-content-md-start justify-content-around align-items-center h-100">
            {/* <div className="">
                <Link className="nav_link" to="/add-company-profile">
                  Add Company
                </Link>
              </div> */}
            <div className="">
              <Link className="nav_link" to="/add-review">
                Rate Manager
              </Link>
            </div>
            <div className="">
              <Link className="nav_link ps-lg-5 ps-md-3" to="/add-manager-profile">
                Add Manager
              </Link>
            </div>
            {/* <div className="">
                  <Link className="nav_link ps-lg-5 ps-md-3" to="/trending-news">
                  Trending News
                  </Link>
                </div>
            */}
            <div className="">
              <Link className="nav_link ps-lg-5 ps-md-3" to="/contact-us">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default LinkNavbar;
